import { graphql } from '@search/gql-client/src';

export const confirmEmailMutation = graphql`
  mutation ConfirmEmailMutation($email: String, $sessionId: String) {
    confirmEmail(email: $email, sessionId: $sessionId) {
      ... on ConfirmEmailType {
        otpSession {
          id
          passCodeLength
          retrySendDelayInSec
        }
      }
      ... on SuccessfulMailConfirmation {
        emailConfirmed
      }
    }
  }
`;
